<template>
  <section
    class="about-section section-padding"
    :style="`background-color: var(--c-${vars.backgroundColor}); color: ${vars.textColor ? `var(--c-${vars.textColor})` : 'var(--c-text-primary)'}`"
  >
    <div id="about-3">
      <div class="container">
        <div class="row gx-lg-5">
          <div class="col-xl-6 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay=".2s">
            <div class="about-img-wrap">
              <div class="image-one" :data-background="vars.photoImage"></div>
              <div class="image-two" :data-background="vars.thumbnailImage"></div>
            </div>
          </div>
          <div class="col-xl-6 col-lg-6 col-md-6">
            <div class="about-content-wrap">
              <div class="section-title">
                <div>
                  <h2>
                    <svg
                      v-if="vars.isVisibleBool"
                      width="1em"
                      height="52"
                      viewBox="0 0 41 47"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      class="flex-shrink-0"
                      style="display: inline"
                    >
                      <rect width="40.9678" height="40.9678" fill="#E4002B" />
                      <circle cx="12.7821" cy="4.69764" r="2.18495" fill="white" />
                      <circle cx="28.5136" cy="4.69764" r="2.18495" fill="white" />
                      <circle cx="36.161" cy="9.94151" r="2.18495" fill="white" />
                      <circle cx="20.6478" cy="9.94151" r="2.18495" fill="white" />
                      <circle cx="5.13465" cy="9.94151" r="2.18495" fill="white" />
                      <circle cx="12.7821" cy="15.2946" r="2.18495" fill="white" />
                      <circle cx="28.5136" cy="15.2946" r="2.18495" fill="white" />
                      <circle cx="36.161" cy="20.5385" r="2.18495" fill="white" />
                      <circle cx="20.6478" cy="20.5385" r="2.18495" fill="white" />
                      <circle cx="5.13465" cy="20.5385" r="2.18495" fill="white" />
                      <circle cx="12.7821" cy="25.8916" r="2.18495" fill="white" />
                      <circle cx="28.5136" cy="25.8916" r="2.18495" fill="white" />
                      <circle cx="36.161" cy="31.1355" r="2.18495" fill="white" />
                      <circle cx="20.6478" cy="31.1355" r="2.18495" fill="white" />
                      <circle cx="5.13465" cy="31.1355" r="2.18495" fill="white" />
                      <circle cx="12.7821" cy="36.4886" r="2.18495" fill="white" />
                      <circle cx="28.5136" cy="36.4886" r="2.18495" fill="white" /></svg
                    ><span v-if="vars.isVisibleBool">&nbsp;</span>{{ vars.titleText }}
                  </h2>
                </div>
              </div>
              <p v-for="(item, index) in descriptions" :key="index" class="tw-mb-9">
                {{ item.description }}
              </p>
            </div>
            <div class="row mt-60 md:tw-min-h-[200px]">
              <div v-for="(item, idx) in items" :key="idx" class="col-xl-4 col-lg-4 col-md-4">
                <div class="single-counter-box">
                  <h2 class="counter-number">{{ item.number }}</h2>
                  <h5 :style="{ color: 'var(--c-text-secondary)' }">
                    {{ item.title }}
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';
export default defineNuxtComponent({
  mixins: [ComponentMixin],

  data() {
    return {
      isVisible: false,
    };
  },

  computed: {
    descriptions() {
      return this.groupedVariables.descriptions;
    },
    photos() {
      return this.groupedVariables.photos;
    },
    items() {
      return this.groupedVariables.items;
    },
  },

  methods: {
    isExternalLink(url: string) {
      return url.includes('http');
    },
  },
});
</script>
